<!--
 * @Author: Tahiti
 * @Date: 2025-12-24 17:18:36
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-30 15:03:51
 * @Description: 
 * @FilePath: /weryai-web/components/Tool/allCategoryInspiration.vue
-->
<script setup lang="ts">
import { ref, reactive, onMounted, computed, watch } from 'vue'
import { useI18n } from '~/composables/useI18n'
import inspiration from '~/locales/modules/inspiration'

const { t } = useI18n()

// const category = computed(() => {
//     return [
//         {
//             label: t('inspiration.categoryAll'),
//             value: ''
//         },
//         // {
//         //     label: t('inspiration.categoryHot'),
//         //     value: 'HOT_TRENDS'
//         // },
//         // {
//         //     label: '图片',
//         //     value: 'IMG_ADS'
//         // },
//         // {
//         //     label: '视频',
//         //     value: 'VIDEO_ADS'
//         // }
//     ]
// })

// 当前分类
const currentCategory = ref('')
// 更改标签
// const changeCategoryType = (type: string) => {
//     currentCategory.value = type
//     console.log('标签改变', type);
// }

// 传递数据类型
const props = defineProps({
    inspirationTypes: {
        type: Array<string>,
        default: [],
    },
})
</script>

<template>
    <div class="mt-10">
        <h2 class="text-white text-2xl font-medium mb-5">
            {{ t('inspiration.title') }}
        </h2>
        <!-- 原分类标签 -->
        <!-- <div class="category">
            <span v-for="item in category" :key="item.value" class="category-label" :class="{'active': currentCategory == item.value}"  @click="changeCategoryType(item.value)">{{ item.label }}</span>
        </div> -->
    </div>
    <inspiration-water-full
        showType="category"
        :inspirationType="currentCategory"
        :types="inspirationTypes"
    ></inspiration-water-full>
</template>
